import SearchPage, {
  getServerSideProps as getSearchServerSideProps
} from 'pages/Hotel/Search'
import {getValidLocale} from 'utils/localization/language'
import * as z from 'zod'

import type {GetServerSideProps} from 'next'

export default SearchPage

const SeoSrpPathParams = z
  .object({
    placeId: z.string().refine(val => Number.isInteger(Number(val)), {
      message: 'Invalid placeId'
    }),
    locale: z.string().refine(val => getValidLocale(val), {
      message: 'Unknown locale'
    })
  })
  .loose()

export const getServerSideProps: GetServerSideProps = async context => {
  // Validate path params before calling any downstream service. An invalid
  // placeId or locale can only ever 404, so bail out early.
  if (!SeoSrpPathParams.safeParse(context.params).success) {
    return {notFound: true}
  }

  return getSearchServerSideProps(context)
}
